import { Component, OnInit, Input, Output, ElementRef, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { formatDate, DatePipe, DOCUMENT } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { APIService } from '../../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Action } from 'rxjs/internal/scheduler/Action';

@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.component.html',
  styleUrls: ['./task-detail.component.scss']
})
export class TaskDetailComponent implements OnInit {

  public minDate: Date = new Date();

  @Input() taskData: any;
  @Input() mdlRef: any;

  taskDoneMdlRef: any;
  modalReference: any;
  closeResult: any;
  userList: Array<any> = [];
  isShowDtls : boolean = false;

  jarvisData: any = [];
  agencyData: any = [];
  JrUserID: number = 0;
  jUserID: number = 0;

  objTaskData: any = {
    taskID: 0,
    task: '',
    targetDT: '',
    status: '',
    statusID: '0',
    touserName:'',
    touserID: '0',
    tags: [],
    details: '',
    statusNote: '',
    priorityID: 0,
    completionDate: '',
    createduserID: 0,
    toUserName: '',
    toUserEmail: '',
    oldUserID: 0,
    oldToUserName: '',
    oldToUserEmail: '',
    replyTo: '',
    fromUserName: '',
    createdUserName: '',
    createdUserEmailID: '',
    projectName: '',
    projectStageName: ''
  }

  oldStatus: number = 0; 
  isEditDetails : string = '';

  sendEmailTo: string = '';
  sendEmailFrom: string = '';

  isDateLableShow: boolean = true;
  editDateNew: any = new Date();

  taskdoneBy: number = 0;
  
  isPriority: boolean = true;
  search: any = '';
  taskDoneImageVal: any ='';
  resp: any;
  fileData: any;
  fileName: any;
  fileToUpload: any;
  imagePreview: any;
  imageLink: any = "";
  isGGL: any = false;
  showImage: any = false;
  isImage: any = false;
  taskDoneDocName: any = "";
  @ViewChild('inputStockSearch') inputStockSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('taskDoneModal', { static: false }) taskDoneModal!: ElementRef;
  // changePriorityID: number= 0;

  constructor(private modalService: NgbModal, private apiService: APIService,private SpinnerLoader: NgxSpinnerService,private http: HttpClient) { }

  ngOnInit(): void {
    let users = this.apiService.getCookie('J');
    if(users){
      this.userList = JSON.parse(users);
      this.jUserID = this.userList[0].UserID
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
      this.JrUserID = this.jarvisData[0].UserID;
      this.objTaskData.toUserName = this.jarvisData[0].UserName
      this.objTaskData.fromUserName = this.jarvisData[0].UserName;
      let users = this.userList.filter((o: any) => o.UserID == this.jarvisData[0].UserID);
      this.sendEmailFrom = users[0].Email
    }
    if(this.jarvisData.length > 0 && (this.jarvisData[0].AgencyIDs == "1" || this.jarvisData[0].AgencyIDs == "276689" || this.jarvisData[0].AgencyIDs == "276064" || this.jarvisData[0].AgencyIDs == "230836" || this.jarvisData[0].AgencyIDs == "104210"
      || this.jarvisData[0].AgencyIDs == "295117")) {
      this.isGGL = true;
    }

    let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
        }
    if(this.taskData){
      this.objTaskData.taskID = this.taskData.TaskID;
      this.objTaskData.task = this.taskData.Task;
      this.objTaskData.targetDT = new Date(this.taskData.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#");
      this.objTaskData.status = this.taskData.StatusID;
      this.objTaskData.touserName = this.taskData.ToUserName;
      this.objTaskData.details = this.taskData.Detail;
      this.objTaskData.statusNote = this.taskData.StatusNote;
      this.objTaskData.priorityID = this.taskData.Priority;
      this.objTaskData.completionDate = this.taskData.CompletionDT;
      this.objTaskData.touserID = this.taskData.ToUserID;
      this.objTaskData.createduserID = this.taskData.CreatedUserID;
      this.oldStatus = this.taskData.StatusID;
      this.objTaskData.replyTo = this.sendEmailFrom;
      let users = this.userList.filter((o: any) => o.UserID == this.taskData.ToUserID);
      this.objTaskData.projectName = this.taskData.projectName ? this.taskData.projectName : "";
      this.objTaskData.projectStageName = this.taskData.projectStageName ? this.taskData.projectStageName : "";
      this.taskDoneImageVal = this.taskData.TaskDoneImage ? this.taskData.TaskDoneImage : ""; 
      let imageArray = this.taskDoneImageVal.split(".");
      let imageLength = imageArray.length;
      let checkImg = imageArray[imageLength - 1]; 
      if(checkImg == "jpeg" || checkImg == "png" || checkImg == "jpg"){
        this.isImage = true;
      }
      if(this.apiService.fn_isLiveURL() == true){
        this.imageLink = "https://biziverse.com/ERPAPI/" + this.taskDoneImageVal;
      }
      else{ 
        this.imageLink = "http://localhost:50456/" + this.taskDoneImageVal;
      }
      if (users.length > 0) {
        this.objTaskData.oldUserID = users[0].UserID;
        this.objTaskData.oldToUserName = users[0].Name;
        this.objTaskData.oldToUserEmail = users[0].Email;        
        this.objTaskData.toUserName = users[0].Name;
        this.objTaskData.toUserEmail = users[0].Email;        
      }

      let createdUsers = this.userList.filter((o: any) => o.UserID == this.taskData.CreatedUserID);
      if(createdUsers.length > 0){
        this.objTaskData.createdUserName= createdUsers[0].Name;
        this.objTaskData.createdUserEmailID = createdUsers[0].Email;
      }
      else{
        this.objTaskData.createdUserName = this.taskData.FromUserName;;
      }
      // this.objTaskData.tags = [{
      //   name: 'LED'
      // },
      // {
      //   name: 'Red'
      // },
      // {
      //   name: 'Light'
      // }]; 
    }

    // if(this.UserID == this.objTaskData.executiveID){
    //   this.isEdit = true;
    // }else{
    //   this.isEdit = false;
    // }
    let emailUserID = this.taskData.CreatedUserID;
    var toEmailData = $.grep(this.userList, function(o: any){ return o.UserID == emailUserID })
    if(toEmailData.length > 0){
      this.sendEmailTo = toEmailData[0].Email
    }

    let sendPause = this.taskData.ToUserID;
    var sendPauseData = $.grep(this.userList, function(o: any){ return o.UserID == sendPause })
    if(sendPauseData.length > 0){
      this.objTaskData.toUserEmail = sendPauseData[0].Email
    }
  }
  async uploadSEFileNew(callback: any) {
      let sPath = 'TaskDone/';
      var img = "";
      if (this.fileToUpload) {
          img = this.fileToUpload.name;
          this.fileName = img;
      }
      if (img != "") {
          var ServerPath = sPath;
          let url: string = "";
          if(this.apiService.fn_isLiveURL() == true){
              url = "https://biziverse.com/ERPAPI/webservice.asmx/UploadSFile";
          }
          else{ 
              url = "http://localhost:50456/WebService.asmx/UploadSFile";
          }
          this.resp = await this.http.post(url, {
              data: this.fileData,
              path: typeof (img) != 'undefined' ? img : '',
              serverpath: sPath,
          }).toPromise();
          if (this.resp.d.error) {
              alert("Please upload an image, .pdf or .zip file!");
              $('#addAttechment').val('');
              callback(false);
          }
          else {
              this.taskDoneImageVal = this.resp.d.message;
              callback(true);
          }
      }
  }
  addAttechmentFile() {
    $('#addAttechment').click();
  }
  
  changeStatus(statusID: number, id: number){
      this.objTaskData.status = statusID;
      // this.taskUpdate(this.objTaskData.status);
      this.taskUpdate(id);
      // this.taskEditData(2);
  }

  /** Close Task Detail Modal */
  closeTaskModal(action: string) {
    // this.objTaskData.status = id;
    this.mdlRef.close(action);
    this.taskDoneMdlRef.close();
    this.modalReference.close("Cross click");
  }

   // ADD button for new model open add group and subgroup :-
   openChangeExecutive(content: any) {
    if(this.objTaskData.createduserID == this.JrUserID && (this.objTaskData.status == 0)){
      this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'exceChange', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  // ADD button for new model open add group and subgroup :-
  openChangeDetail(content: any) {
    this.isEditDetails = this.objTaskData.details;
    this.modalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', windowClass: 'editDetails', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  openTaskDoneModal(content: any) {
    
    this.modalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  saveTaskDoneImage () {
    if(this.fileName){
      this.uploadSEFileNew((obj: boolean) => {
          if(obj == true){
              this.fileName = this.taskDoneImageVal;
              this.changeStatus(3,3);
          };                        
      });
    }
    else{
      this.changeStatus(3,3);
    }
  }
   //File Upload Region
   handleFileInput(files: FileList) {
      this.fileToUpload = files.item(0);
      let file: File = files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
          this.fileData = reader.result;
      };
      if (this.fileToUpload) {
          this.fileName = this.fileToUpload.name;
          let imageArray = this.fileName.split(".");
          let imageLength = imageArray.length;
          let checkImg = imageArray[imageLength - 1]; 
          if(checkImg == "jpeg" || checkImg == "png" || checkImg == "jpg"){
            this.showImage = true;
          }
      }
  }
  removeAttechUploadedFile() {
    this.fileName = "";
    $('#addAttechment').val('');
    
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  //User List Color
  changeColorUserList(ind: any, userID: number){
    var clr = ""
    clr = userID == this.objTaskData.touserID ? 'bz-drkBlueBtn-lb-active' : 'bz-drkBlueBtn-lb';
    return clr; 

    switch(ind) { 
      case 0: { 
        clr = userID == this.objTaskData.touserID ? 'activeOrange' : 'orangeBadge'
         break; 
      } 
      case 1: {
        clr = userID == this.objTaskData.touserID ? 'activeYellow' : 'yellowBadge'
        break; 
      } 
      case 2: { 
        clr = userID == this.objTaskData.touserID ? 'activeGreen' : 'greenBadge'
         break; 
      } 
      case 3: { 
        clr = userID == this.objTaskData.touserID ? 'activeTeal' : 'tealBadge'
         break; 
      } 
      case 4: { 
        clr = userID == this.objTaskData.touserID ? 'activeBlue' : 'blueBadge'
         break; 
      } 
      case 5: { 
        clr = userID == this.objTaskData.touserID ? 'activedarkblue' : 'darkBlueBadge'
         break; 
      } 
      case 6: { 
        clr = userID == this.objTaskData.touserID ? 'activeBrown' : 'brownBadge'
         break; 
      } 
    
   }
   
  }

  //taskEditData() - Task Edit Functionality Check
  taskEditData(id: any){
  
      var tempData = [{
            'TaskID': this.objTaskData.taskID,
            'Task': this.objTaskData.task,
            'Detail': this.objTaskData.details,
            'StatusID': this.objTaskData.status,
            'Priority': this.objTaskData.priorityID,
            'ToUserID': this.objTaskData.touserID,
            'ToUserName': this.objTaskData.touserName,
            'Tags': '',
            'ExpCompletionDT': new Date(this.objTaskData.targetDT).customFormat("#DD#-#MMM#-#YY#"),
            'StatusNote': this.objTaskData.statusNote ? this.objTaskData.statusNote  : '',
            'DoneDT': this.objTaskData.completionDate ? this.objTaskData.completionDate : '',
            'DoneUserID': this.objTaskData.touserID,
            'FromUserName': this.objTaskData.fromUserName,
            'ToUserEmail': this.objTaskData.toUserEmail,
            'ChangeID': id ? id : 0,
            'OldUserName': this.objTaskData.oldToUserName,
            'OldToUserEmail': this.objTaskData.oldToUserEmail,
            'ReplyTo': this.objTaskData.replyTo,
            'OldUserID': this.objTaskData.oldUserID
        }];

        let myParams = [{
                  myUserID: this.jarvisData[0].UserID,
                  myToken: this.jarvisData[0].WebToken,
                  forAgencyID: this.jarvisData[0].AgencyIDs,
                  myAgencyIDs: this.jarvisData[0].AgencyIDs,
                  myLastSyncDT: null,
                  isWeb: true,
                  ForERPAgencyID: this.agencyData[0].ERPAgencyID,
                  actionType: 'set',
                  moduleID: 28,
                  data: JSON.stringify(tempData)
              }];

        this.apiService.sendChange(myParams, this.successTasksEdit.bind(this, id), this.failureResp.bind(this));     
  }

  //successTasksEdit - success edit handler
  successTasksEdit( id: any, res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    }
    else {
        let tmpData = JSON.parse(res.updatePackage).Table[0];
        if (tmpData.ErrCode != -1) {
            alert(tmpData.ErrMsg);
            return;
        }
        else {
          // this.apiService.swalConfirm('Are you sure?', 'Done', '');
          // return;

            if(id == 1 || id == 0 || id == 3 || id == 4 || id == 5){
              this.apiService.successAlert(id == 1 ? 'Task transferred.' : id == 0 ? 'Current status updated.' : id == 3 ? 'Detail changed.' : id == 4 ? 'Target date changed.' : id == 5 ? 'Priority Changed.' : '');
            }
            else if(this.objTaskData.status == 0 || this.objTaskData.status == 1 || this.objTaskData.status == 2 || this.objTaskData.status == 3){
                this.apiService.successAlert(this.objTaskData.status == 0 ? 'Task reopened.' : this.objTaskData.status == 1 ? 'Task paused.' :  this.objTaskData.status == 2 ? 'Task cancelled.' : this.objTaskData.status == 3 ? 'Task done.' : '');
            }
           
            // - Local Cookie Update
            if(this.objTaskData.status == 2 || this.objTaskData.status == 3){
              var localStorageData: any = this.apiService.getCookie('tsk');
              if (localStorageData != null && localStorageData != "" && localStorageData != "null") {
                  localStorageData = JSON.parse(localStorageData);
              }
              else {
                localStorageData = [];
              }
              
              let findIndexofLocalStorage = localStorageData.findIndex((x: any) => x.TaskID === this.objTaskData.taskID);
              if (findIndexofLocalStorage > -1) {
                localStorageData[findIndexofLocalStorage].IsRemove = true;
                localStorageData.splice(findIndexofLocalStorage, 1);
                this.apiService.setCookie('tsk',JSON.stringify(localStorageData));
              }
            }
            this.closeTaskModal("Done");  
        } 
    }
  }

    //failureResp - failure handler
    failureResp(res: any) {
      this.SpinnerLoader.hide();
      if (res.error) {
      }
      else {
          alert(res.message);
      }
    }

  //selectExe() - select User
  selectExeChane(id: any,){
    var selectedUsere = $.grep(this.userList, function(o: any){ return o.UserID == id });
    if(selectedUsere.length > 0){
      this.objTaskData.userID = selectedUsere[0].UserID
      this.objTaskData.touserID = selectedUsere[0].UserID;
      this.objTaskData.touserName = selectedUsere[0].Name;
      this.objTaskData.toUserEmail = selectedUsere[0].Email
      this.closeModal();
      this.taskEditData(1);
    }
}

public closeModal() {
  this.modalReference.close();
}

//editDate - change date
editDate(date: any){
  if(this.objTaskData.createduserID == this.JrUserID && (this.objTaskData.status == 0))
  {
    this.objTaskData.targetDT = new Date(date);
    this.isDateLableShow = false;
  }
}

//saveNewDate() - save after change date
saveNewDate(){
  //alert(new Date(this.objTaskData.targetDT).customFormat("#DD#-#MMM#-#YY#"));
  this.objTaskData.targetDT = new Date(this.objTaskData.targetDT).customFormat("#DD#-#MMM#-#YY#");
  this.isDateLableShow = true;
  this.taskEditData(4);
}

//change - Priority
changePriority(changePriorityID: number){
  if(this.objTaskData.createduserID == this.JrUserID && (this.objTaskData.status == 0)){
    this.objTaskData.priorityID = changePriorityID;
    this.isPriority = false;
  }
}

savePriority(){
  this.objTaskData.priorityID = this.objTaskData.priorityID;
  this.isPriority = true;
  this.taskEditData(5);
}

//editDetailsnotes()
editDetailsnotes(){
  this.objTaskData.details = this.isEditDetails;
  this.taskEditData(3);
  this.modalReference.close();
}

taskUpdate(id: number){
  // its for if my task done by me or other
  let attechLink = '';
  if (this.fileName) {
    attechLink = "Uploads/TaskDone/" + this.taskDoneImageVal;
  }
  else {
        attechLink = "";
  }

  if(this.objTaskData.createduserID == this.JrUserID && this.objTaskData.touserID != this.JrUserID){
    this.taskdoneBy = 1
  }
  else if(this.objTaskData.createduserID != this.JrUserID && this.objTaskData.touserID == this.JrUserID){
    this.taskdoneBy = 2
  }
  else{
    this.taskdoneBy = 0
  }

  let isConfirm: boolean = true;
    if(this.objTaskData.status == 2){
      isConfirm = confirm("Are you sure you wish to" + (this.objTaskData.status == 2 ? ' cancel this task?' : '')) 
    }
  if (isConfirm) {   
    var tempData = [{
      'TaskID': this.objTaskData.taskID,
      'ActionType': 'STTS',
      'StatusID': this.objTaskData.status,
      'Tags': '',
      'StatusNote': this.objTaskData.statusNote ? this.objTaskData.statusNote  : '',
      'EmailTo': this.sendEmailTo ? this.sendEmailTo : '',
      'EmailFrom': this.objTaskData.toUserName,
      'Task': this.objTaskData.task,
      'ToUserEmail': this.objTaskData.toUserEmail,
      'DoneByMe': this.taskdoneBy,      
      'FromUserName': this.objTaskData.fromUserName,
      'ToUserName': this.objTaskData.touserName,
      'LoginUserName': this.jarvisData[0].UserName,
      'TaskCreatoerName': this.objTaskData.createdUserName,
      'TaskReceiverName': this.objTaskData.touserName,
      'ChangeID': id,
      'TaskCreatorUserID': this.objTaskData.createduserID,
      'TaskReceiverUserID': this.objTaskData.touserID,
      'TaskCreatorEmail': this.objTaskData.createdUserEmailID,
      'TaskReceiverEmail': this.objTaskData.toUserEmail,
      'TaskDoneImage': attechLink
  }];

  let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'update',
            moduleID: 28,
            data: JSON.stringify(tempData)
        }];

  this.apiService.sendChange(myParams, this.successTasksUpdate.bind(this, id), this.failureRespUpdate.bind(this));
  }
  else{
    this.objTaskData.status = this.oldStatus;
  } 
}

//successTasksEdit - success edit handler
successTasksUpdate(id: any, res: any) {
  this.SpinnerLoader.hide();
  if (res.error) {
  }
  else {
      const isLive = this.apiService.fn_isLiveURL();
      let tmpData = JSON.parse(res.updatePackage).Table[0];
      if (tmpData.ErrCode != -1) {
          alert(tmpData.ErrMsg);
          return;
      }
      else {
        if(id == 1 || id == 0 || id == 10){
          this.apiService.successAlert(id == 1 ? 'Task transferred.' : id == 0 ? 'Status updated.' : id == 10 ? 'Task paused.' : '');
        }
        else if(this.objTaskData.status == 0 || this.objTaskData.status == 1 || this.objTaskData.status == 2){
            this.apiService.successAlert(this.objTaskData.status == 0 ? 'Task reopened.' : this.objTaskData.status == 1 ? 'Task paused.' :  this.objTaskData.status == 2 ? 'Task cancelled.' : this.objTaskData.status == 3 ? 'Task done.' : '');
        }
        else if(this.objTaskData.status == 3){
          if(this.taskDoneModal){
            const content = this.taskDoneModal.nativeElement;
            this.taskDoneMdlRef = this.modalService.open(this.taskDoneModal, {ariaLabelledBy: 'tsk-done-modal', backdrop: 'static', keyboard: false, windowClass: 'taskDoneModal' });
            setTimeout(() => {
              this.taskDoneMdlRef.close();
              window.location.href = (isLive ? '/ERP' : '') + "/Tasks?T=1";
            }, 2000);
            this.taskDoneMdlRef.componentInstance.content = content;
            this.taskDoneMdlRef.result.then((result: any) => {
              this.closeResult = `Closed with: ${result}`;
            }, (reason: any) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
          }
        }
       
        // - Local Cookie Update
        if(this.objTaskData.status == 2 || this.objTaskData.status == 3){
          var localStorageData: any = this.apiService.getCookie('tsk');
          if (localStorageData != null && localStorageData != "" && localStorageData != "null") {
              localStorageData = JSON.parse(localStorageData);
          }
          else {
            localStorageData = [];
          }
          
          let findIndexofLocalStorage = localStorageData.findIndex((x: any) => x.TaskID === this.objTaskData.taskID);
          if (findIndexofLocalStorage > -1) {
            localStorageData[findIndexofLocalStorage].IsRemove = true;
            localStorageData.splice(findIndexofLocalStorage, 1);
            this.apiService.setCookie('tsk',JSON.stringify(localStorageData));
          }
        }        
        this.closeTaskModal("Done");  
        this.modalReference.close("Cross click");
    } 
  }
}

  //failureRespUpdate - failure handler
  failureRespUpdate(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    }
    else {
        alert(res.message);
    }
  }

  //#region "Send Reminder"

  sendReminder(obj: any){
    let toUsers = this.userList.filter((x: any) => x.UserID == this.objTaskData.touserID);
    let senders = this.userList.filter((x: any) => x.UserID == this.jarvisData[0].UserID);
    let tempData: Array<any> = [{
      TaskID: this.objTaskData.taskID,
      Task: this.objTaskData.task,
      Detail: this.objTaskData.details,
      TaskReceiverEmail: toUsers[0].Email,
      TaskCreatorEmail: senders[0].Email,
      TaskCreatoerName: senders[0].Name,
      TaskReceiverName: this.objTaskData.touserName
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'sendReminder',
      moduleID: 28,
      data: JSON.stringify(tempData)
  }];

    this.apiService.swalConfirm("Would you like to remind " + this.objTaskData.touserName + " about the task #" + this.objTaskData.taskID + "?", () => {
      this.apiService.sendChange(myParams, this.successSendReminder.bind(this), this.failureReminderResp.bind(this));
    });
  }

  //saveSendRemonder() - Reminder send to Propgation
  successSendReminder(res: any){
    this.apiService.successAlert("Reminder sent.");
  }

  failureReminderResp(res: any){
    console.log(Error, res);
  }

  //#endregion

} 
